import { GenericFeedbackWidgetProps } from '../generic-feedback-widget/types.ts'
import { SalesFeedbackWidgetStep } from './types.ts'
import { getFeedbackWidgetKey } from '../generic-feedback-widget/utils.ts'

export const SalesFeedbackSteps = {
  LOCAL_ENERGY: 'localEnergy',
  PRODUCER_INFO: 'producerInfo',
  TARIFF_INFO: 'tariffInfo',
  RECOMMEND_BOLT: 'recommendBolt',
  BOLT_CLIENT_REASON: 'boltClientReason',
  SATISFACTION_SALES_PARTNER: 'satisfactionSalesPartner',
  DESCRIPTION_PARTNER_CONTACT: 'descriptionPartnerContact'
} as const

export const SALES_SURVEY_FEEDBACK_WIDGET_ID = 'sales-survey-feedback-widget'

export const SALES_FEEDBACK_CONFIG: GenericFeedbackWidgetProps<SalesFeedbackWidgetStep>['config'] = {
  [SalesFeedbackSteps.LOCAL_ENERGY]: {
    type: 'radio',
    question: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.localEnergy.title),
    options: [
      { value: 'yes', label: getFeedbackWidgetKey('common', ($) => $.yes) },
      { value: 'no', label: getFeedbackWidgetKey('common', ($) => $.no) }
    ]
  },
  [SalesFeedbackSteps.PRODUCER_INFO]: {
    type: 'radio',
    question: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.producerInfo.title),
    weight: 0.3,
    options: [
      { value: 'yes', label: getFeedbackWidgetKey('common', ($) => $.yes), score: 4 },
      { value: 'no', label: getFeedbackWidgetKey('common', ($) => $.no), score: -1 },
      { value: 'unknown', label: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.producerInfo.unknownProducer), score: 1 }
    ]
  },
  [SalesFeedbackSteps.TARIFF_INFO]: {
    type: 'radio',
    question: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.tariffInfo.title),
    weight: 0.3,
    options: [
      { value: 'yes', label: getFeedbackWidgetKey('common', ($) => $.yes), score: 4 },
      { value: 'no', label: getFeedbackWidgetKey('common', ($) => $.no), score: -1 }
    ]
  },
  [SalesFeedbackSteps.RECOMMEND_BOLT]: {
    type: 'rating',
    question: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.recommendBolt.title),
    weight: 0.1,
    range: {
      limit: 6,
      maxScoreLabel: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.recommendBolt.maxScoreLabel),
      minScoreLabel: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.recommendBolt.minScoreLabel)
    }
  },
  [SalesFeedbackSteps.BOLT_CLIENT_REASON]: {
    type: 'checkbox',
    question: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.boltClientReason.title),
    maxOptions: 2,
    options: [
      { value: 'green', label: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.boltClientReason.options.green) },
      { value: 'cheap', label: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.boltClientReason.options.cheap) },
      { value: 'service', label: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.boltClientReason.options.service) },
      { value: 'brand', label: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.boltClientReason.options.brand) },
      { value: 'local', label: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.boltClientReason.options.local) },
      { value: 'advised', label: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.boltClientReason.options.advised) },
      {
        value: 'other',
        label: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.boltClientReason.options.other),
        triggerExtraInput: true,
        extraInputPlaceholder: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.boltClientReason.otherPlaceholder)
      }
    ]
  },
  [SalesFeedbackSteps.SATISFACTION_SALES_PARTNER]: {
    type: 'rating',
    question: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.satisfactionSalesPartner.title),
    weight: 0.3,
    range: {
      limit: 6,
      maxScoreLabel: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.satisfactionSalesPartner.maxScoreLabel),
      minScoreLabel: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.satisfactionSalesPartner.minScoreLabel)
    }
  },
  [SalesFeedbackSteps.DESCRIPTION_PARTNER_CONTACT]: {
    type: 'textArea',
    optional: true,
    question: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.descriptionPartnerContact.title),
    placeholder: getFeedbackWidgetKey('feedbackWidget', ($) => $.salesFeedback.descriptionPartnerContact.placeholder)
  }
}

export const SALES_FEEDBACK_WIDGET_STEPS_ORDER: SalesFeedbackWidgetStep[] = [
  SalesFeedbackSteps.LOCAL_ENERGY,
  SalesFeedbackSteps.PRODUCER_INFO,
  SalesFeedbackSteps.TARIFF_INFO,
  SalesFeedbackSteps.RECOMMEND_BOLT,
  SalesFeedbackSteps.BOLT_CLIENT_REASON,
  SalesFeedbackSteps.SATISFACTION_SALES_PARTNER,
  SalesFeedbackSteps.DESCRIPTION_PARTNER_CONTACT
]
